module.exports = __webpack_public_path__ + "img/jinsehotLogo.ed03a46f.svg";